import { Box, Card, CardContent, Typography } from '@mui/material';
import { FC } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
	getErrorTypesLoader,
	getErrorTypes,
	getErrorCorrection,
} from 'redux/reducers/errorCorrections/selectors';
import { nanoid } from '@reduxjs/toolkit';
import { COLORS } from 'services/constants/colors';
import { EditedTextParameter } from '../ErrorCorrection/EdittedTextParameter';
import { HintsItem } from './HintsItem';

export const AdditionalInformation: FC = () => {
	const item = useSelector(getErrorCorrection);

	const typeOfErrorId = item?.typeOfError;

	const errorTypes = useSelector(getErrorTypes);
	const errorTypesLoader = useSelector(getErrorTypesLoader);

	const errorType = errorTypes?.find(type => type.id === typeOfErrorId);

	const emailTemplates = errorType?.emailTemplate?.split('||');
	const newEmailTemplates = emailTemplates?.map(template => {
		if (!item) {
			return template;
		}
		let templateTmp = template.replace(/#XXX/g, `*${item.externalOrderId}*`);
		if (item?.responsibleUser?.fullName)
			templateTmp = templateTmp.replace(
				/CORRECTORXXX/g,
				`*${String(item?.responsibleUser?.fullName ?? '')}*`,
			);
		else templateTmp = templateTmp.replace(/CORRECTORXXX/g, `*CORRECTOR*`);
		if (item?.responsibleUser)
			templateTmp = templateTmp.replace(/NAMEXXX/g, `*${String(item?.clientname ?? '')}*`);
		else templateTmp = templateTmp.replace(/NAMEXXX/g, `*CLIENT NAME*`);
		return templateTmp;
	});
	const hints = errorType?.hint?.split('||') ?? [];
	return (
		<Card>
			<CardContent>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						gap: 2,
					}}
				>
					<Typography
						sx={{
							fontWeight: 'bold',
						}}
						color="primary"
					>
						Additional Information
					</Typography>

					<Box
						sx={{
							border: `1px solid ${COLORS.BORDER}`,
							borderRadius: '12px',
							padding: '10px',
						}}
					>
						<Typography
							sx={{
								marginBottom: '10px',
							}}
							color="primary"
						>
							Hints
						</Typography>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								gap: 1,
							}}
						>
							{hints.map(hint => {
								return <HintsItem key={nanoid()} hint={hint} />;
							})}
						</Box>
					</Box>
					{newEmailTemplates?.map((template, index) => (
						<EditedTextParameter
							key={nanoid()}
							name="Email template"
							// value={errorTypes?.find((type) => type.id === typeOfErrorId)?.emailTemplate ?? ''}
							value={template}
							onChange={() => {}}
						/>
					))}
				</Box>
			</CardContent>
		</Card>
	);
};
